import React, { useContext } from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import AppContext from 'context/Context';
import Flex from 'components/common/Flex';
import dayjs from 'dayjs';
import HolidayService from './HolidayService';

const getCircleStackIcon = (icon, transform) => (
  <span className="fa-stack ms-n1 me-3">
    <FontAwesomeIcon icon="circle" className="text-200 fa-stack-2x" />
    <FontAwesomeIcon
      icon={icon}
      transform={transform ?? ''}
      className="text-primary fa-stack-1x"
      inverse
    />
  </span>
);

const EventModalMediaContent = ({ icon, heading, content, children }) => (
  <Flex className="mt-3">
    {getCircleStackIcon(icon)}
    <div className="flex-1">
      <h6>{heading}</h6>
      {children || <p className="mb-0 text-justify">{content}</p>}
    </div>
  </Flex>
);

const CalendarHolidayModal = ({
  setIsOpenEventModal,
  isOpenEventModal,
  modalEventContent
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const handleClose = () => {
    setIsOpenEventModal(!isOpenEventModal);
  };
  const approveHoliday = () => {
    HolidayService.approveHoliday(identifier).then(() => {
      console.log(identifier);
      setStatusKey('APPROVED');
      setIsOpenEventModal(!isOpenEventModal);
    });
  };
  const rejectHoliday = () => {
    HolidayService.rejectHoliday(identifier).then(() => {
      console.log(identifier);
      setStatusKey('REJECTED');
      setIsOpenEventModal(!isOpenEventModal);
    });
  };
  const { title, end, start } = isOpenEventModal && modalEventContent.event;
  const {
    description,
    location,
    organizer,
    schedules,
    profile,
    identifier,
    status,
    editButtons
  } = isOpenEventModal && modalEventContent.event.extendedProps;
  // const [approved, setApproved] = isOpenEventModal && modalEventContent.event.extendedProps && useState(status === 'APPROVED'); // DON'T USE IT
  // const [rejected, setRejected] = isOpenEventModal && modalEventContent.event.extendedProps && useState(status === 'REJECTED'); // DON'T USE IT
  //const statusKey = useState(status)[0];
  const setStatusKey = useState(status)[1];

  return (
    <Modal
      show={isOpenEventModal}
      onHide={handleClose}
      contentClassName="border"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="bg-light px-card border-bottom-0"
      >
        <Modal.Title>
          <h5 className="mb-0">{title}</h5>
          {organizer && (
            <p className="mb-0 fs--1 mt-1 fw-normal">
              by <a href="#!">{organizer}</a>
            </p>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-card pb-card pt-1 fs--1">
        {description && (
          <EventModalMediaContent
            icon="align-left"
            heading="Description"
            content={description}
          />
        )}
        {(end || start) && (
          <EventModalMediaContent icon="calendar-check" heading="Date and Time">
            <p className="mb-1">
              {dayjs(start).format('dddd, MMMM DD, YYYY, hh:mm A')}
              {end && (
                <>
                  -<br />
                  {dayjs(end).format('dddd, MMMM DD, YYYY, hh:mm A')}
                </>
              )}
            </p>
          </EventModalMediaContent>
        )}
        {profile && (
          <EventModalMediaContent icon="user" heading="Requested by">
            <div
              className="mb-1"
              dangerouslySetInnerHTML={{
                __html: profile.firstName + ' ' + profile.lastName
              }}
            />
          </EventModalMediaContent>
        )}
        {profile && (
          <EventModalMediaContent icon="tag" heading="Status">
            <div
              className="mb-1"
              dangerouslySetInnerHTML={{ __html: status }}
            />
          </EventModalMediaContent>
        )}
        {location && (
          <EventModalMediaContent icon="map-marker-alt" heading="Location">
            <div
              className="mb-1"
              dangerouslySetInnerHTML={{ __html: location }}
            />
          </EventModalMediaContent>
        )}
        {schedules && (
          <EventModalMediaContent icon="clock" heading="Schedule">
            <ul className="list-unstyled timeline mb-0">
              {schedules.map((schedule, index) => (
                <li key={index}>{schedule.title}</li>
              ))}
            </ul>
          </EventModalMediaContent>
        )}
      </Modal.Body>
      <Modal.Footer className="bg-light px-card border-top-0">
        <Button
          as={Link}
          to={'/app/holidays/' + identifier + '/edit'}
          variant="falcon-default"
          size="sm"
        >
          <FontAwesomeIcon icon="pencil-alt" className="fs--2 me-2" />
          <span>Edit</span>
        </Button>
        {status === 'REQUESTED' && editButtons && (
          <>
            <Button
              as={Button}
              onClick={approveHoliday}
              variant="falcon-primary"
              size="sm"
            >
              <span>Approve request</span>
              <FontAwesomeIcon icon="thumbs-up" className="fs--2 ms-1" />
            </Button>
            <Button
              as={Button}
              onClick={rejectHoliday}
              variant="falcon-primary"
              size="sm"
            >
              <span>Reject request</span>
              <FontAwesomeIcon icon="thumbs-down" className="fs--2 ms-1" />
            </Button>
          </>
        )}
        <Button
          as={Link}
          to={'/app/holidays/' + identifier}
          variant="falcon-primary"
          size="sm"
        >
          <span>See more details</span>
          <FontAwesomeIcon icon="angle-right" className="fs--2 ms-1" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EventModalMediaContent.propTypes = {
  icon: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  content: PropTypes.string,
  children: PropTypes.node
};

CalendarHolidayModal.propTypes = {
  setIsOpenEventModal: PropTypes.func.isRequired,
  isOpenEventModal: PropTypes.bool.isRequired,
  modalEventContent: PropTypes.object.isRequired
};

export default CalendarHolidayModal;
